import { useMemo } from "react";
import { Image } from "@storybook";
import { LabelDescription } from "components";

import "./unauthorized-domain.scss";
import { useInstance } from "hooks";

export const UnauthorizedDomain = () => {
  const { instance_id } = useInstance();
  const origin = `https://admin.stage.satschel.com/auth?id=${
    instance_id ?? ""
  }`;

  const OWNER_STEPS = [
    `Open the Simplici app.`,
    `Navigate to "Settings."`,
    `Go to "General Settings."`,
    `Find "Whitelisted Domains."`,
    `Click on "Add Domain."`,
    `Enter the website domain (e.g. "${origin}").`,
    `Click "Save."`,
  ];

  const DOMAIN_EXAMPLES = [`${window.location.origin}`, `${origin}`];
  const WILDCARD_EXAMPLES = [`${origin}//*.${origin}`];

  const whatToDo = useMemo(
    () => (
      <LabelDescription
        label="What to do:"
        description={
          <div>
            <div>
              Please contact the account administrator and request them to add
              the website to the whitelist.
            </div>
          </div>
        }
      />
    ),
    []
  );

  const needHelp = useMemo(
    () => (
      <LabelDescription
        description={
          " Need help? Check out our tutorial for a step-by-step guide."
        }
      />
    ),
    []
  );

  const otherSteps = OWNER_STEPS.map((step, index) => {
    if (step.includes(`"`)) {
      const stepArr = step.split(`"`);
      return (
        <div
          className="unauthorized-domain-wrapper__step-list"
          key={`${step}__${index.toString()}`}
        >
          {stepArr[0]}
          <span className="UnauthorizedDomain__ownerStep--bold">
            &ldquo;{stepArr[1] ?? ""}&ldquo;
          </span>
          {stepArr[2] ?? ""}
        </div>
      );
    } else
      return (
        <div
          className="unauthorized-domain-wrapper__step-list"
          key={`${step}__${index.toString()}`}
        >
          {step}
        </div>
      );
  });

  const ownerSteps = useMemo(
    () => (
      <div className="UnauthorizedDomain__owner">
        <LabelDescription
          label=" Owners, here&lsquo;s how you can add your domain:"
          description={<div>{otherSteps}</div>}
        />
      </div>
    ),
    [otherSteps]
  );

  const examples = useMemo(
    () => (
      <LabelDescription
        label="Example:"
        description={
          <>
            {DOMAIN_EXAMPLES.map((example) => (
              <div className="UnauthorizedDomain__example" key={example}>
                {example}
              </div>
            ))}
          </>
        }
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const wildcard = useMemo(
    () => (
      <LabelDescription
        label="for wildcard domain"
        description={
          <>
            {WILDCARD_EXAMPLES.map(
              (wildcard) => (
                <div
                  className="UnauthorizedDomain__wildcard--subTitle"
                  key={wildcard}
                >
                  {wildcard}
                </div>
              ),
              []
            )}
          </>
        }
      />
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const renderMainComponent = useMemo(
    () => (
      <div className="unauthorized-domain-wrapper">
        <div className="unauthorized-domain-wrapper__inner content-center">
          <div className="flex direction-col unauthorized-domain-wrapper__details">
            <Image
              fileName="missing.svg"
              className="unauthorized-domain-wrapper__missing"
            />

            <div className="sublabel">
              Oops! It seems like the website you are trying to access is not
              whitelisted.{" "}
            </div>

            {whatToDo}
            {needHelp}
            {ownerSteps}
            {examples}
            {wildcard}
          </div>
        </div>
      </div>
    ),
    [examples, needHelp, ownerSteps, whatToDo, wildcard]
  );

  return renderMainComponent;
};
